import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPlasiyerSiparisDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPlasiyerSiparisDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  UpdatePlasiyerSiparisKuyruk: number;
  UpdatePlasiyerSiparisKuyruk_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  GoBack: any;
  GoBack_dummy: any;
  GetPlasiyerSiparisTra: any[];
  GetPlasiyerSiparisTra_dummy: any[];
  UpdatePlasiyerSiparisMasMarka: number;
  UpdatePlasiyerSiparisMasMarka_dummy: number;
  HesaplaSiparisDetay: any[];
  HesaplaSiparisDetay_dummy: any[];
  GetPlasiyerSiparisFaturaDetaylari: any[];
  GetPlasiyerSiparisFaturaDetaylari_dummy: any[];
  GetCariYurticiBilgisiPlasiyer: any[];
  GetCariYurticiBilgisiPlasiyer_dummy: any[];
  UpdatePlasiyerSiparisFiyat: number;
  UpdatePlasiyerSiparisFiyat_dummy: number;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  UpdatePlasiyerSiparisFaturaBilgileri: number;
  UpdatePlasiyerSiparisFaturaBilgileri_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp504507Visible: "visible" | "hidden";
  isComp766352Visible: "visible" | "hidden";
  isComp316718Visible: "visible" | "hidden";
  isComp130580Visible: "visible" | "hidden";
  isComp685469Visible: "visible" | "hidden";
  isComp250992Visible: "visible" | "hidden";
  isComp652258Visible: "visible" | "hidden";
  isComp459301Visible: "visible" | "hidden";
  isComp511736Visible: "visible" | "hidden";
  isComp763897Enabled: "enabled" | "disabled";
}

export class PlasiyerSiparisDetay_ScreenBase extends React.PureComponent<
  IPlasiyerSiparisDetay_ScreenProps,
  any
> {
  plasiyersiparisdetay_997506_value_kuikaTableRef: React.RefObject<any>;
  plasiyersiparisdetay_809200_value_kuikaSelectBoxRef: React.RefObject<any>;
  plasiyersiparisdetay_28966_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 286595,
          PropertyName: "label",
          Value: "Add Discount",
          TagName: "Button3_label",
        },
        {
          Id: 504507,
          PropertyName: "label",
          Value: "Transfer to Netsis",
          TagName: "Button2_label",
        },
        {
          Id: 766352,
          PropertyName: "value",
          Value:
            "Before proceeding with the Netsis transfer, please check that all entered data is correct.",
          TagName: "Label83_value",
        },
        {
          Id: 218195,
          PropertyName: "value",
          Value: "Invoice Queued to be Transferred to Netsis",
          TagName: "Label84_value",
        },
        {
          Id: 216882,
          PropertyName: "value",
          Value: "Order Number",
          TagName: "Label42_value",
        },
        {
          Id: 686042,
          PropertyName: "value",
          Value: "Request Number",
          TagName: "Label44_value",
        },
        {
          Id: 471490,
          PropertyName: "value",
          Value: "Current Code",
          TagName: "Label46_value",
        },
        {
          Id: 334223,
          PropertyName: "value",
          Value: "History",
          TagName: "Label48_value",
        },
        {
          Id: 187003,
          PropertyName: "value",
          Value: "Order Note",
          TagName: "Label50_value",
        },
        {
          Id: 786345,
          PropertyName: "value",
          Value: "Sender",
          TagName: "Label51_value",
        },
        {
          Id: 881964,
          PropertyName: "title",
          Value: "Stock Code",
          TagName: "TableTemplateColumn9_title",
        },
        {
          Id: 71000,
          PropertyName: "title",
          Value: "Stock Name",
          TagName: "TableTemplateColumn10_title",
        },
        {
          Id: 78408,
          PropertyName: "title",
          Value: "Brand",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 221536,
          PropertyName: "title",
          Value: "Amount",
          TagName: "TableTemplateColumn12_title",
        },
        {
          Id: 794540,
          PropertyName: "title",
          Value: "Unit Price",
          TagName: "TableTemplateColumn14_title",
        },
        {
          Id: 340489,
          PropertyName: "title",
          Value: "Net Price",
          TagName: "TableTemplateColumn15_title",
        },
        {
          Id: 161484,
          PropertyName: "title",
          Value: "Net Amount",
          TagName: "TableTemplateColumn16_title",
        },
        {
          Id: 897550,
          PropertyName: "label",
          Value: "Save",
          TagName: "Button1_label",
        },
        {
          Id: 613305,
          PropertyName: "value",
          Value: "Total Amount",
          TagName: "Label24_value",
        },
        {
          Id: 482792,
          PropertyName: "value",
          Value: "General Discount 1",
          TagName: "Label37_value",
        },
        {
          Id: 227071,
          PropertyName: "value",
          Value: "General Discount 2",
          TagName: "Label36_value",
        },
        {
          Id: 795706,
          PropertyName: "value",
          Value: "General Discount 3",
          TagName: "Label69_value",
        },
        {
          Id: 6681,
          PropertyName: "value",
          Value: "Net Amount",
          TagName: "Label30_value",
        },
        {
          Id: 827790,
          PropertyName: "value",
          Value: "Kdv",
          TagName: "Label33_value",
        },
        {
          Id: 877549,
          PropertyName: "value",
          Value: "Grand Total",
          TagName: "Label72_value",
        },
        {
          Id: 497239,
          PropertyName: "value",
          Value: "Payment Method",
          TagName: "Label75_value",
        },
        {
          Id: 417965,
          PropertyName: "value",
          Value: "Customer Request Number",
          TagName: "Label76_value",
        },
        {
          Id: 301973,
          PropertyName: "value",
          Value: "Packaging Type",
          TagName: "Label77_value",
        },
        {
          Id: 36097,
          PropertyName: "value",
          Value: "Export Type",
          TagName: "Label78_value",
        },
        {
          Id: 449483,
          PropertyName: "value",
          Value: "Package Description",
          TagName: "Label79_value",
        },
        {
          Id: 53923,
          PropertyName: "value",
          Value: "Project Code",
          TagName: "Label80_value",
        },
        {
          Id: 802014,
          PropertyName: "value",
          Value: "Special Note",
          TagName: "Label81_value",
        },
        {
          Id: 411670,
          PropertyName: "value",
          Value: "Delivery Day",
          TagName: "Label82_value",
        },
        {
          Id: 90310173,
          PropertyName: "15e795f4-e6c3-b533-b0f7-8a9343d7da05_notify",
          Value: "Transaction Successfully Completed and Queued",
          TagName: "Notify_notify",
          IsNotify: true,
        },
        {
          Id: 98819529,
          PropertyName: "39be20b8-75f7-6f7e-20b0-7e6585cac77d_notify",
          Value: "Save Successful",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "d45da75d-83a2-42c0-ae0c-09a7982b45a5",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 504507, PropertyName: "label", Value: "Netsise Aktar" },
        {
          Id: 766352,
          PropertyName: "value",
          Value:
            "Netsis aktarımına geçmeden önce, lütfen girilen tüm verilerin doğruluğunu kontrol edin.",
        },
        {
          Id: 218195,
          PropertyName: "value",
          Value: "Fatura Netsise Aktarılmak İçin Kuyruğa Alındı",
        },
        { Id: 593641, PropertyName: "value", Value: "B2B Sipariş Detayları" },
        { Id: 216882, PropertyName: "value", Value: "Sipariş Numarası" },
        { Id: 686042, PropertyName: "value", Value: "Talep Numarası" },
        { Id: 471490, PropertyName: "value", Value: "Cari Kod" },
        { Id: 334223, PropertyName: "value", Value: "Tarih" },
        { Id: 187003, PropertyName: "value", Value: "Sipariş Notu" },
        { Id: 786345, PropertyName: "value", Value: "Gönderen" },
        { Id: 881964, PropertyName: "title", Value: "Stok Kodu" },
        { Id: 419178, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 71000, PropertyName: "title", Value: "Stok Adı" },
        { Id: 282856, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 78408, PropertyName: "title", Value: "Marka" },
        {
          Id: 626485,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 221536, PropertyName: "title", Value: "Miktar" },
        { Id: 204196, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 675721, PropertyName: "title", Value: "Title" },
        { Id: 940146, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 157309, PropertyName: "placeholder", Value: "15" },
        { Id: 794540, PropertyName: "title", Value: "Birim Fiyat" },
        { Id: 12822, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 340489, PropertyName: "title", Value: "Net Fiyat" },
        { Id: 434995, PropertyName: "value", Value: "[datafield:netfiyat]" },
        { Id: 161484, PropertyName: "title", Value: "Net Tutar" },
        { Id: 954839, PropertyName: "value", Value: "[datafield:nettutar]" },
        { Id: 349372, PropertyName: "title", Value: "KalemNot" },
        { Id: 107486, PropertyName: "value", Value: "[datafield:kalemnot]" },
        { Id: 286595, PropertyName: "label", Value: "İskonto Ekle" },
        { Id: 586971, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 59494, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 673694, PropertyName: "value", Value: "Fatura Bilgileri" },
        { Id: 497239, PropertyName: "value", Value: "Ödeme Şekli" },
        { Id: 417965, PropertyName: "value", Value: "Müşteri Talep No" },
        { Id: 301973, PropertyName: "value", Value: "Paketleme Şekli" },
        { Id: 36097, PropertyName: "value", Value: "İhracat Tipi" },
        { Id: 449483, PropertyName: "value", Value: "Paket Açıklama" },
        { Id: 53923, PropertyName: "value", Value: "Proje Kodu" },
        { Id: 802014, PropertyName: "value", Value: "Özel Not" },
        { Id: 411670, PropertyName: "value", Value: "Teslim Günü" },
        { Id: 897550, PropertyName: "label", Value: "Kaydet" },
        { Id: 615818, PropertyName: "value", Value: "Ödeme Bilgileri" },
        { Id: 613305, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 482792, PropertyName: "value", Value: "Genel Iskonto 1" },
        { Id: 227071, PropertyName: "value", Value: "Genel Iskonto 2" },
        { Id: 795706, PropertyName: "value", Value: "Genel Iskonto 3" },
        { Id: 6681, PropertyName: "value", Value: "Net Tutar" },
        { Id: 827790, PropertyName: "value", Value: "Kdv" },
        { Id: 877549, PropertyName: "value", Value: "Genel Toplam" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.plasiyersiparisdetay_997506_value_kuikaTableRef = React.createRef();
    this.plasiyersiparisdetay_586971_value_kuikaTextInputRef =
      React.createRef();
    this.plasiyersiparisdetay_59494_value_kuikaTextInputRef = React.createRef();
    this.plasiyersiparisdetay_752048_value_kuikaTextInputRef =
      React.createRef();
    this.plasiyersiparisdetay_296409_value_kuikaTextInputRef =
      React.createRef();
    this.plasiyersiparisdetay_763897_value_kuikaTextInputRef =
      React.createRef();
    this.plasiyersiparisdetay_809200_value_kuikaSelectBoxRef =
      React.createRef();
    this.plasiyersiparisdetay_307254_value_kuikaTextInputRef =
      React.createRef();
    this.plasiyersiparisdetay_28966_value_kuikaSelectBoxRef = React.createRef();
    this.plasiyersiparisdetay_222512_value_kuikaTextInputRef =
      React.createRef();
    this.plasiyersiparisdetay_482513_value_kuikaTextInputRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      TriggerEvent: "",
      UpdatePlasiyerSiparisKuyruk: 0,
      Notify: false,
      GoBack: "",
      GetPlasiyerSiparisTra: [],
      UpdatePlasiyerSiparisMasMarka: 0,
      HesaplaSiparisDetay: [],
      GetPlasiyerSiparisFaturaDetaylari: [],
      GetCariYurticiBilgisiPlasiyer: [],
      UpdatePlasiyerSiparisFiyat: 0,
      NAVIGATE: "",
      IfThenElse: false,
      dataSource_809200: [
        { key: "1", text: "FOB" },
        { key: "2", text: "CIF" },
        { text: "CF", key: "3" },
        { text: "FOT", key: "4" },
        { text: "IHRAÇ KAYITLI", key: "5" },
        { text: "DAF", key: "6" },
        { text: "EXW", key: "7" },
        { text: "iHR KUR FARKI", key: "8" },
        { text: "CIP", key: "9" },
        { text: "CPT", key: "10" },
        { text: "DAT", key: "11" },
        { text: "DAP", key: "12" },
        { text: "DDP", key: "13" },
        { text: "DES", key: "14" },
        { text: "DEQ", key: "15" },
        { text: "DDU", key: "16" },
        { text: "FCA", key: "17" },
        { text: "FAS", key: "18" },
        { text: "CFR", key: "19" },
      ],
      dataSource_28966: [
        { key: "A", text: "A" },
        { text: "R", key: "R" },
      ],
      isComp504507Visible: "hidden",
      isComp766352Visible: "hidden",
      isComp316718Visible: "hidden",
      isComp130580Visible: "hidden",
      isComp685469Visible: "hidden",
      isComp250992Visible: "hidden",
      isComp652258Visible: "hidden",
      isComp459301Visible: "hidden",
      isComp511736Visible: "hidden",
      isComp763897Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("plasiyersiparisdetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.PlasiyerSiparisDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("plasiyersiparisdetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("plasiyersiparisdetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PlasiyerSiparisDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      plasiyersiparisdetay_586971_value:
        this.props.screenInputs.CariKod ?? this.props.screenInputs.carikod,
      plasiyersiparisdetay_59494_value:
        this.props.screenInputs.siparisNumarasi ??
        this.props.screenInputs.siparisnumarasi,
      plasiyersiparisdetay_752048_value:
        this.state.GetPlasiyerSiparisFaturaDetaylari?.at?.(0)?.odemeTipi ??
        undefined,
      plasiyersiparisdetay_296409_value:
        this.props.screenInputs.TalepNo ?? this.props.screenInputs.talepno,
      plasiyersiparisdetay_763897_value:
        this.state.GetPlasiyerSiparisTra?.at?.(0)?.musteriMarka ?? undefined,
      plasiyersiparisdetay_809200_value:
        this.state.GetPlasiyerSiparisFaturaDetaylari?.at?.(0)?.ihracatTipi ??
        undefined,
      plasiyersiparisdetay_307254_value:
        this.state.GetPlasiyerSiparisFaturaDetaylari?.at?.(0)?.paketAciklama ??
        undefined,
      plasiyersiparisdetay_28966_value:
        this.state.GetPlasiyerSiparisFaturaDetaylari?.at?.(0)?.projeKodu ??
        undefined,
      plasiyersiparisdetay_222512_value:
        this.state.GetPlasiyerSiparisFaturaDetaylari?.at?.(0)?.ozelNot ??
        undefined,
      plasiyersiparisdetay_482513_value:
        this.state.GetPlasiyerSiparisFaturaDetaylari?.at?.(0)?.teslimGunu ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PlasiyerSiparisDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      carikod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_586971_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_59494_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      marka_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetPlasiyerSiparisTra !== undefined
            ? stateVars.GetPlasiyerSiparisTra?.length > 0
              ? stateVars.GetPlasiyerSiparisTra[0].musteriMarka
              : null
            : this.state.GetPlasiyerSiparisTra?.length > 0
            ? this.state.GetPlasiyerSiparisTra[0].musteriMarka
            : null
        ),
        "string"
      ),
      SiparisNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
      SiparisNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_59494_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_586971_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SiparisNumarasi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_59494_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      FirmaKodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_586971_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerSiparisDetay/PlasiyerSiparisDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetPlasiyerSiparisTra = result?.data.getPlasiyerSiparisTra;

    formVars.plasiyersiparisdetay_763897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisTra !== undefined
        ? stateVars.GetPlasiyerSiparisTra?.length > 0
          ? stateVars.GetPlasiyerSiparisTra[0].musteriMarka
          : null
        : this.state.GetPlasiyerSiparisTra?.length > 0
        ? this.state.GetPlasiyerSiparisTra[0].musteriMarka
        : null
    );
    stateVars.UpdatePlasiyerSiparisMasMarka =
      result?.data.updatePlasiyerSiparisMasMarka;
    stateVars.HesaplaSiparisDetay = result?.data.hesaplaSiparisDetay;
    formVars.plasiyersiparisdetay_160433_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].toplamTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].toplamTutar
        : null
    );
    formVars.plasiyersiparisdetay_358993_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
        : null
    );
    formVars.plasiyersiparisdetay_455946_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
        : null
    );
    formVars.plasiyersiparisdetay_684287_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
        : null
    );
    formVars.plasiyersiparisdetay_34144_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].netTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].netTutar
        : null
    );
    formVars.plasiyersiparisdetay_674851_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].kdvTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].kdvTutar
        : null
    );
    formVars.plasiyersiparisdetay_162796_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelToplam
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelToplam
        : null
    );
    stateVars.isComp250992Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp652258Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp459301Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp511736Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].kdvTutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetPlasiyerSiparisFaturaDetaylari =
      result?.data.getPlasiyerSiparisFaturaDetaylari;
    formVars.plasiyersiparisdetay_752048_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].odemeTipi
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].odemeTipi
        : null
    );
    formVars.plasiyersiparisdetay_809200_value =
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].ihracatTipi
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].ihracatTipi
        : null;
    formVars.plasiyersiparisdetay_307254_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].paketAciklama
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].paketAciklama
        : null
    );
    formVars.plasiyersiparisdetay_28966_value =
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].projeKodu
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].projeKodu
        : null;
    formVars.plasiyersiparisdetay_222512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].ozelNot
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].ozelNot
        : null
    );
    formVars.plasiyersiparisdetay_482513_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].teslimGunu
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].teslimGunu
        : null
    );
    stateVars.isComp504507Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp766352Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp316718Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetCariYurticiBilgisiPlasiyer =
      result?.data.getCariYurticiBilgisiPlasiyer;
    stateVars.isComp685469Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
            ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
            : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
            ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerSiparisDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerSiparisDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp504507Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp766352Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp316718Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
            ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
              ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
              : null
            : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
            ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].isKuyrugaAlindi
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    ReactSystemFunctions.setValueOf(
      this,
      "plasiyersiparisdetay_148010_value",
      ReactSystemFunctions.value(
        this,
        "plasiyersiparisdetay_59494_value",
        "value"
      ),
      "value"
    );

    ReactSystemFunctions.setValueOf(
      this,
      "plasiyersiparisdetay_219444_value",
      ReactSystemFunctions.value(
        this,
        "plasiyersiparisdetay_586971_value",
        "value"
      ),
      "value"
    );

    stateVars.dataSource_997506 =
      stateVars.GetPlasiyerSiparisTra ?? this.state.GetPlasiyerSiparisTra;

    formVars.plasiyersiparisdetay_752048_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].odemeTipi
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].odemeTipi
        : null
    );

    formVars.plasiyersiparisdetay_763897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisTra !== undefined
        ? stateVars.GetPlasiyerSiparisTra?.length > 0
          ? stateVars.GetPlasiyerSiparisTra[0].musteriMarka
          : null
        : this.state.GetPlasiyerSiparisTra?.length > 0
        ? this.state.GetPlasiyerSiparisTra[0].musteriMarka
        : null
    );

    stateVars.isComp685469Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
            ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
            : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
            ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyersiparisdetay_809200_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].ihracatTipi
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].ihracatTipi
        : null
    );

    formVars.plasiyersiparisdetay_307254_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].paketAciklama
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].paketAciklama
        : null
    );

    formVars.plasiyersiparisdetay_28966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].projeKodu
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].projeKodu
        : null
    );

    formVars.plasiyersiparisdetay_222512_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].ozelNot
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].ozelNot
        : null
    );

    formVars.plasiyersiparisdetay_482513_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisFaturaDetaylari !== undefined
        ? stateVars.GetPlasiyerSiparisFaturaDetaylari?.length > 0
          ? stateVars.GetPlasiyerSiparisFaturaDetaylari[0].teslimGunu
          : null
        : this.state.GetPlasiyerSiparisFaturaDetaylari?.length > 0
        ? this.state.GetPlasiyerSiparisFaturaDetaylari[0].teslimGunu
        : null
    );

    formVars.plasiyersiparisdetay_160433_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].toplamTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].toplamTutar
        : null
    );

    stateVars.isComp250992Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyersiparisdetay_358993_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
        : null
    );

    stateVars.isComp652258Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyersiparisdetay_455946_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
        : null
    );

    stateVars.isComp459301Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyersiparisdetay_684287_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
        : null
    );

    formVars.plasiyersiparisdetay_34144_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].netTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].netTutar
        : null
    );

    stateVars.isComp511736Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].kdvTutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyersiparisdetay_674851_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].kdvTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].kdvTutar
        : null
    );

    formVars.plasiyersiparisdetay_162796_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelToplam
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_504507_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.PlasiyerSiparisDetayComponent_897550_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerSiparisDetayComponent_504507_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PlasiyerSiparisDetayComponent_504507_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      sipno_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerSiparisDetay/PlasiyerSiparisDetayComponent_504507_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePlasiyerSiparisKuyruk =
      result?.data.updatePlasiyerSiparisKuyruk;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerSiparisDetayComponent_504507_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerSiparisDetayComponent_504507_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "15e795f4_e6c3_b533_b0f7_8a9343d7da05_notify",
        this.defaultML,
        "İşlem Başarıyla Gerçekleşti ve Kuyruğa Alındı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_228308_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_997506_onRowEditFinished = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_997506_birimFiyat",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "plasiyersiparisdetay_997506_value",
          ".id"
        ),
        "number"
      ),
      carikod_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_586971_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SiparisNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_59494_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SiparisNumarasi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_59494_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CariKod_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_586971_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerSiparisDetay/PlasiyerSiparisDetayComponent_997506_onRowEditFinished",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePlasiyerSiparisFiyat =
      result?.data.updatePlasiyerSiparisFiyat;
    stateVars.GetPlasiyerSiparisTra = result?.data.getPlasiyerSiparisTra;

    formVars.plasiyersiparisdetay_763897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisTra !== undefined
        ? stateVars.GetPlasiyerSiparisTra?.length > 0
          ? stateVars.GetPlasiyerSiparisTra[0].musteriMarka
          : null
        : this.state.GetPlasiyerSiparisTra?.length > 0
        ? this.state.GetPlasiyerSiparisTra[0].musteriMarka
        : null
    );
    stateVars.HesaplaSiparisDetay = result?.data.hesaplaSiparisDetay;
    formVars.plasiyersiparisdetay_160433_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].toplamTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].toplamTutar
        : null
    );
    formVars.plasiyersiparisdetay_358993_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
        : null
    );
    formVars.plasiyersiparisdetay_455946_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
        : null
    );
    formVars.plasiyersiparisdetay_684287_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
        : null
    );
    formVars.plasiyersiparisdetay_34144_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].netTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].netTutar
        : null
    );
    formVars.plasiyersiparisdetay_674851_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].kdvTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].kdvTutar
        : null
    );
    formVars.plasiyersiparisdetay_162796_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelToplam
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelToplam
        : null
    );
    stateVars.isComp250992Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp652258Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp459301Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp511736Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.HesaplaSiparisDetay !== undefined
            ? stateVars.HesaplaSiparisDetay?.length > 0
              ? stateVars.HesaplaSiparisDetay[0].kdvTutar
              : null
            : this.state.HesaplaSiparisDetay?.length > 0
            ? this.state.HesaplaSiparisDetay[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerSiparisDetayComponent_997506_onRowEditFinished1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerSiparisDetayComponent_997506_onRowEditFinished1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_997506 =
      stateVars.GetPlasiyerSiparisTra ?? this.state.GetPlasiyerSiparisTra;
    formVars.plasiyersiparisdetay_763897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPlasiyerSiparisTra !== undefined
        ? stateVars.GetPlasiyerSiparisTra?.length > 0
          ? stateVars.GetPlasiyerSiparisTra[0].musteriMarka
          : null
        : this.state.GetPlasiyerSiparisTra?.length > 0
        ? this.state.GetPlasiyerSiparisTra[0].musteriMarka
        : null
    );

    formVars.plasiyersiparisdetay_160433_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].toplamTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].toplamTutar
        : null
    );

    formVars.plasiyersiparisdetay_358993_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk1Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk1Tutar
        : null
    );

    formVars.plasiyersiparisdetay_455946_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk2Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk2Tutar
        : null
    );

    formVars.plasiyersiparisdetay_684287_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelIsk3Tutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelIsk3Tutar
        : null
    );

    formVars.plasiyersiparisdetay_34144_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].netTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].netTutar
        : null
    );

    formVars.plasiyersiparisdetay_674851_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].kdvTutar
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].kdvTutar
        : null
    );

    formVars.plasiyersiparisdetay_162796_value = ReactSystemFunctions.toString(
      this,
      stateVars.HesaplaSiparisDetay !== undefined
        ? stateVars.HesaplaSiparisDetay?.length > 0
          ? stateVars.HesaplaSiparisDetay[0].genelToplam
          : null
        : this.state.HesaplaSiparisDetay?.length > 0
        ? this.state.HesaplaSiparisDetay[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_286595_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "PlasiyerIskontoEkle",
      "siparisNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "PlasiyerSiparisDetay",
      "PlasiyerIskontoEkle",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "399453",
      null,
      null,
      "true",
      "500px",
      "55vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_897550_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyersiparisdetay_752048_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyersiparisdetay_752048_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyersiparisdetay_28966_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyersiparisdetay_28966_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PaketlemeSekli_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_763897_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IhracatTipi_0: ReactSystemFunctions.convertToTypeByName(null, "string"),
      PaketAciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_307254_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OzelNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_222512_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OdemeTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_752048_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TeslimGunu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_482513_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProjeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_28966_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TalepNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_296409_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerSiparisDetay/PlasiyerSiparisDetayComponent_897550_onClick_if0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePlasiyerSiparisFaturaBilgileri =
      result?.data.updatePlasiyerSiparisFaturaBilgileri;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_897550_onClick_else0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid:
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_809200_value",
            "value",
            "",
            "key",
            ""
          ),
          null
        ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
              ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
                ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
                : null
              : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("False", "string")
        ),
      message: "Zorunlu Alan !",
      formName: "plasiyersiparisdetay_809200_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyersiparisdetay_752048_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyersiparisdetay_752048_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "plasiyersiparisdetay_28966_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "Zorunlu Alan !",
      formName: "plasiyersiparisdetay_28966_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PaketlemeSekli_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_763897_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      IhracatTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_809200_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      PaketAciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_307254_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OzelNot_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_222512_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      OdemeTipi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_752048_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TeslimGunu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_482513_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProjeKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_28966_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      TalepNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyersiparisdetay_296409_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerSiparisDetay/PlasiyerSiparisDetayComponent_897550_onClick_else0",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePlasiyerSiparisFaturaBilgileri =
      result?.data.updatePlasiyerSiparisFaturaBilgileri;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_897550_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariYurticiBilgisiPlasiyer !== undefined
            ? stateVars.GetCariYurticiBilgisiPlasiyer?.length > 0
              ? stateVars.GetCariYurticiBilgisiPlasiyer[0].isYurtici
              : null
            : this.state.GetCariYurticiBilgisiPlasiyer?.length > 0
            ? this.state.GetCariYurticiBilgisiPlasiyer[0].isYurtici
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.PlasiyerSiparisDetayComponent_897550_onClick_if0();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.PlasiyerSiparisDetayComponent_897550_onClick_else0();
      if (isErrorOccurred) return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "39be20b8_75f7_6f7e_20b0_7e6585cac77d_notify",
        this.defaultML,
        "Kaydetme İşlemi Başarılı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_59494_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    ReactSystemFunctions.setValueOf(
      this,
      "plasiyersiparisdetay_148010_value",
      ReactSystemFunctions.value(
        this,
        "plasiyersiparisdetay_59494_value",
        "value"
      ),
      "value"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_586971_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    ReactSystemFunctions.setValueOf(
      this,
      "plasiyersiparisdetay_219444_value",
      ReactSystemFunctions.value(
        this,
        "plasiyersiparisdetay_586971_value",
        "value"
      ),
      "value"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerSiparisDetayComponent_107486_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [399453] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PlasiyerSiparisDetayPageInit();
    }
  }
}
